<template>
  <div class="animated fadeIn">
        <b-row>
        <b-col sm="6" lg="3">
        <b-card no-body class="bg-primary" v-on:click="bcardclick()">
          <b-card-body class="pb-0">
            <h4 class="mb-0"><i class="fa fa-users"></i>{{total_user}}</h4><br>
            <p>Active User: {{active_user}} </br>Inactive/Locked User: {{inactive_user}}</p>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col sm="6" lg="3">
        <b-card no-body class="bg-info">
          <b-card-body class="pb-0">
            <h4 class="mb-0"><i class="fa fa-rupee"></i></h4>
            <p>Balance to Collect</p>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col sm="6" lg="3">
        <b-card no-body class="bg-warning">
          <b-card-body class="pb-0">
            <h4 class="mb-0"><i class="fa fa-rupee"></i></h4>
            <p v-show="hide">{{ dashbd_view }}</p>
            <p>Total Purchase Expenses</p>
          </b-card-body>
        </b-card>
      </b-col>


      <b-col sm="6" lg="3">
        <b-card no-body class="bg-success">
          <b-card-body class="pb-0">
            <h4 class="mb-0"><i class="fa fa-rupee"></i></h4>
            <p>Value of Stock</p>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

<!--/.row-->
<!-- <b-row>
  <b-col md="8">
    <b-card>
      <b-row>
        <b-col sm="5">
          <h4 id="traffic" class="card-title mb-0">SALES REPORT</h4>
          <span v-if="selected == 'Month'">
              <div class="small text-muted">{{mnth}} {{year}}</div>
          </span>
          <span v-else>
              <div class="small text-muted">{{year}}</div>
          </span>
        </b-col>
        <b-col sm="7" class="d-none d-md-block">
          <b-button type="button" variant="primary" class="float-right"><i class="icon-cloud-download"></i></b-button>
          <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
            <b-form-radio-group class="mr-3" id="radiosBtn" buttons button-variant="outline-secondary" v-model="selected" name="radiosBtn">
               
              <b-form-radio class="mx-0" value="Month">Month</b-form-radio>
              <b-form-radio class="mx-0" value="Year">Year</b-form-radio>
            </b-form-radio-group>
          </b-button-toolbar>
        </b-col>
      </b-row>
       <span v-if="selected == 'Month'">
             <main-chart-example class="chart-wrapper" style="height:300px;margin-top:40px;" height="300"></main-chart-example>
       </span>
        <span v-else>
          <main-chart2-example class="chart-wrapper" style="height:300px;margin-top:40px;" height="300"></main-chart2-example>
        </span>
    </b-card>
    
  </b-col>
  <b-col md="4">
    <div class="card">
<div class="card-header">
<i class="fa fa-align-justify"></i> TOP 5 SELLING PRODUCT {{year}}
</div>
<div class="card-body">
   <vue-good-table
      :columns="columns1"
      :rows="rows1"
     
      :pagination-options="{
        enabled: false,
        perPage: 5,
      }"
      styleClass="vgt-table striped bordered table-sm condensed">
       <template slot="table-row" slot-scope="props">
    <span v-if="props.column.field == 'action'">
 

    </span>
    <span v-else>
      {{props.formattedRow[props.column.field]}}
    </span>

  </template>
</vue-good-table>

</div>
</div>
  </b-col>
</b-row>
    
   
    <b-row>
      <b-col md="8">
        <b-card header="RECENT ORDERS">
             <vue-good-table
      :columns="columns3"
      :rows="rows3"
     
      :pagination-options="{
        enabled: false,
        perPage: 5
      }"
      styleClass="vgt-table striped bordered table-sm condensed">
       <template slot="table-row" slot-scope="props">
    <span v-if="props.column.field == 'action'">
       </span>
    <span v-else>
      {{props.formattedRow[props.column.field]}}
    </span>

  </template>
</vue-good-table>

 
        </b-card>
      </b-col>
        <b-col md="4">
    <div class="card">
<div class="card-header">
<i class="fa fa-align-justify"></i> TOP 5 SELLING PRODUCT {{mnth}}
</div>
<div class="card-body">
   <vue-good-table
      :columns="columns2"
      :rows="rows2"
     
      :pagination-options="{
        enabled: false,
        perPage: 5,
      }"
      styleClass="vgt-table striped bordered table-sm condensed">
       <template slot="table-row" slot-scope="props">
    <span v-if="props.column.field == 'action'">
       </span>
    <span v-else>
      {{props.formattedRow[props.column.field]}}
    </span>

  </template>
</vue-good-table>


</div>
</div>
  </b-col>

    </b-row> -->
  </div>
</template>

<script>
// import {mapState} from 'vuex'
// import CardLine1ChartExample from './dashboard/CardLine1ChartExample'
// import CardLine2ChartExample from './dashboard/CardLine2ChartExample'
// import CardLine3ChartExample from './dashboard/CardLine3ChartExample'
// import CardBarChartExample from './dashboard/CardBarChartExample'
// import MainChartExample from './dashboard/MainChartExample'
// import MainChart2Example from './dashboard/MainChart2Example'
// import SocialBoxChartExample from './dashboard/SocialBoxChartExample'
// import CalloutChartExample from './dashboard/CalloutChartExample'
// import { Callout } from '../components/'
// import {mapGetters} from 'vuex'
export default {
  name: 'dashboard',
  computed: {
    dashbd_view: function(){
      if(this.$store.getters.get_is_admin === true){
        this.shopuser()
        // this.get_profit()
        this.get_totaluser()
        // this.prchse_expenses()
        // this.purchase_payment()
        // this.top_SoldProduct()
        // this.show_currentMonth()
        // this.top_crntMnthSoldPrdct()
        // this.recent_order()
        // var now = new Date()
        // this.year = now.getFullYear();
        return true
      }
      else{
        return false
      }
    },
    dashbd_rights: function(){
      return this.$store.getters.get_dashbd_rights
    },
  },
  components: {
    // Callout,
    // CardLine1ChartExample,
    // CardLine2ChartExample,
    // CardLine3ChartExample,
    // CardBarChartExample,
    // MainChartExample,
    // MainChart2Example,
    // SocialBoxChartExample,
    // CalloutChartExample
  },
  data: function () {
    return {
      hide: false,
    //   year:null,
    //   selected: 'Month',
    //   profit:0,
    //   purchase_expenses:0,
      total_user:0,
      active_user:0,
      inactive_user:0,
    //   purchasepayment:0,
    //   mnth:'',
    //   rows1:[],
    //   rows2:[],
    //   rows3:[],
    //     columns: [
    //     {
    //       label: 'Order ID',
    //       field: 'oid',
    //     },
    //     {
    //       label: 'Customer Name',
    //       field: 'name',
    //     },
    //     {
    //       label: 'Date',
    //       field: 'age',
    //       type: 'number',
    //     },
    //     {
    //       label: 'Status',
    //       field: 'createdAt',
    //       type: 'date',
    //       dateInputFormat: 'YYYY-MM-DDThh:mm:ss',
    //       dateOutputFormat: 'Do MMM YYYY',
    //       tdClass: 'text-left',
    //       thClass: 'text-left',
    //     },
    //     {
    //       label: 'Order Total',
    //       field: 'score',
    //     },
    //   ],
    //   columns1:[
    //   {
    //     label:'Pro. Id',
    //     field:'product_id',
    //     width:'15% !important'
    //   },
    //   {
    //     label:'Pro. Name',
    //     field:'product_name',
    //     width:'50% !important'
    //   },
    //   {
    //     label:'Pro. Variant',
    //     field:'variant_id',
    //     width:'30% !important'
    //   },
    //   {
    //     label:'Qty',
    //     field:'sum',
    //     width:'15% !important'
    //   }
    //   ],
    //   columns2:[
    //   {
    //     label:'Pro. Id',
    //     field:'product_id',
    //     width:'15% !important'
    //   },
    //   {
    //     label:'Pro. Name',
    //     field:'product_name',
    //     width:'50% !important'
    //   },
    //    {
    //     label:'Pro. Variant',
    //     field:'variant_id',
    //     width:'30% !important'
    //   },
    //   {
    //     label:'Qty',
    //     field:'sum',
    //     width:'15% !important'
    //   }
    //   ],
    //   columns3:[
    //   {
    //     label:'Custmer Name',
    //     field:'cust_cmp_name',
    //     width:'50% !important'
    //   },
    //   {
    //     label:'Date',
    //     field:'lastupdated_datetime',
    //     type: 'date',
    //     dateInputFormat: 'YYYY-MM-DDThh:mm:ss',
    //     dateOutputFormat: 'Do MMM YYYY',
    //     tdClass: 'text-left',
    //     thClass: 'text-left',
    //     width:'30% !important'
    //   },
    //   {
    //     label:'Order Total',
    //     field:'total_amt_pay',
    //     width:'20% !important'
    //   }
    //   ],
    // }
    }
  },

  created(){

  },

  methods: {
      bcardclick(){
         this.$router.push("/user_management/user_status")
      },

    shopuser(){
      var _this=this
      this.$http.get('/api/shopusers').then(function(response){
      }).catch(function(error){
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null)
          _this.$router.push('/');
        }
        if(error.response.data.error.message === "Cannot read property 'cmpname' of null"){
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null)
          _this.$router.push('/');
        }
      })
    },

    // yearReport(){
    //   var _this=this
    //   this.$http.get('/api/companies/yearReport') .then(function (response) {

    //   })
    //   .catch(function (error) {

    //   });
    // },

    // get_profit(){
    //   var _this=this
    //   this.$http.get('/api/companies/getProfit') .then(function (response) {
    //     if(response.data == 'NaN'){
    //       _this.profit=0
    //     }else{
    //       _this.profit=response.data
    //     }
    //   })
    //   .catch(function (error) {
    //   });
    // },

    get_totaluser(){
      var _this=this
      this.$http.get('/api/users/getTotalUser') .then(function (response) {
        if(response.data !== null ){
          _this.total_user = response.data['total_user'];
          _this.active_user = response.data['active_user'];
          _this.inactive_user = response.data['inactive_user'];
        }
      })
      .catch(function (error) {
        console.log(error)
      });
    },

    // prchse_expenses(){
    //   var _this=this
    //   this.$http.get('/api/companies/purchaseExpenses') .then(function (response) {
        
    //     if(response.data[0]['sum'] == null || response.data[0]['sum'] == NaN){
    //       _this.purchase_expenses=0;
    //     }else{
    //       _this.purchase_expenses=response.data[0]['sum'];
    //     }
    //   })
    //   .catch(function (error) {
    //   });
    // },

    // purchase_payment(){
    //   var _this=this
    //   this.$http.get('/api/companies/purchasePayment') .then(function (response) {
    //     if(response.data[0]['sum'] == null || response.data[0]['sum'] == NaN){
    //       _this.purchasepayment=0;
    //     }else{
    //       _this.purchasepayment=response.data[0]['sum'];
    //     }
    //   })
    //   .catch(function (error) {

    //   });
    // },

    // top_SoldProduct(){
    //   var _this=this
    //   this.$http.get('/api/companies/topSoldProduct') .then(function (response) {
    //     _this.rows1 =response.data
    //   })
    //   .catch(function (error) {
    //     console.log(error.response);
    //   });
    // },

    // show_currentMonth(){
    //   var months = ['January','February','March','April','May','June','July','August','September','October','November','December']
    //   var now = new Date()
    //   this.mnth = months[now.getMonth()].toUpperCase()
    // },
    
    // top_crntMnthSoldPrdct(){
    //   var _this=this
    //   this.$http.get('/api/companies/topCurntMnthSoldProduct') .then(function (response) {
    //     _this.rows2 =response.data
    //   })
    //   .catch(function (error) {

    //   });
    // },

    // recent_order(){
    //   var _this=this
    //   this.$http.get('/api/companies/recentOrder') .then(function (response) {
    //     _this.rows3 =response.data
    //   })
    //   .catch(function (error) {

    //   });
    // },

    // variant (value) {
    //   let $variant
    //   if (value <= 25) {
    //     $variant = 'info'
    //   } else if (value > 25 && value <= 50) {
    //     $variant = 'success'
    //   } else if (value > 50 && value <= 75) {
    //     $variant = 'warning'
    //   } else if (value > 75 && value <= 100) {
    //     $variant = 'danger'
    //   }
    //   return $variant
    // },

    // flag (value) {
    //   return 'flag-icon flag-icon-' + value
    // }

  }
}
</script>



// WEBPACK FOOTER //
// src/views/AdminDashboard.vue